module.exports = __webpack_public_path__ + "static/media/menuConverse.285c051e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuConverse.svg
// module id = 181
// module chunks = 0